import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getVariableGroupList,
  getVariableStencil,
  getVariableStencilList,
} from '@/services/variableService';

const initialState = {
  groups: [],
  stencilList: [],
  stencilVars: [],
  loading: false,
};

export const fetchVariableGroupList = createAsyncThunk(
  'variable/fetchVariableGroupList',
  async (clusterName) => {
    const resp = await getVariableGroupList(clusterName);
    return resp.data;
  },
);

export const fetchVariableStencilList = createAsyncThunk(
  'variable/fetchVariableStencilList',
  async (props) => {
    const resp = await getVariableStencilList(props);
    return resp.data;
  },
);

// 获取所有变量
export const fetchVariableStencil = createAsyncThunk(
  'variable/fetchVariableStencil',
  async (id) => {
    const resp = await getVariableStencil(id);
    return resp.data;
  },
);

export const variableSlice = createSlice({
  name: 'variable',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVariableGroupList.fulfilled, (state, action) => {
        state.groups = action.payload;
      })
      .addCase(fetchVariableStencilList.pending, (state) => {
        state.stencilList = [];
      })
      .addCase(fetchVariableStencilList.fulfilled, (state, action) => {
        state.stencilList = action.payload;
      })
      .addCase(fetchVariableStencil.pending, (state) => {
        state.stencilVars = [];
        state.loading = true;
      })
      .addCase(fetchVariableStencil.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchVariableStencil.fulfilled, (state, action) => {
        state.stencilVars = action.payload;
        state.loading = false;
      });
  },
});

export default variableSlice.reducer;
